/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-01-04 09:45:53
 * @LastEditors: linxi
 * @LastEditTime: 2023-03-16 14:22:30
 */

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootThunkApi } from '../../app/store'
import { sendAsync } from '../../app/applicationSlice'
import * as DT from '../../services/doctorManagement'
import {
  getAllDoctorListFn,
  getAllDoctorListFnPrams,
} from '../../services/doctor'

// 列表
export const getDoctorManagementList = createAsyncThunk<
  void,
  DT.DoctorManagementListPrams,
  RootThunkApi<void>
>('clinic/getDoctorManagementList', async (params, api) => {
  return sendAsync(DT.doctorManagementList(params), api)
})

// 列表
export const getDoctorList = createAsyncThunk<
  void,
  DT.DoctorListPrams,
  RootThunkApi<void>
>('clinic/getDoctorList', async (params, api) => {
  return sendAsync(DT.doctorList(params), api)
})

// 导出
export const getExportData = createAsyncThunk< any, void,RootThunkApi>(
  'clinic/getExportData',
  async (params, api) => {
    return sendAsync(DT.getExportFn(), api)
  }
)

// 详情
export const getDoctorManagementDetail = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>('clinic/getDoctorManagementDetail', async (params, api) => {
  return sendAsync(DT.doctorManagementDetail(params), api)
})

// 保存
export const getDoctorManagementEditSubmit = createAsyncThunk<
  void,
  DT.DoctorManagementEditPrams,
  RootThunkApi<void>
>('clinic/getDoctorManagementEditSubmit', async (params, api) => {
  return sendAsync(DT.doctorManagementEditSubmit(params), api)
})

// 是否展示状态
export const getDoctorManagementUpload = createAsyncThunk<
  void,
  DT.DoctorManagementUploadPrams,
  RootThunkApi<void>
>('clinic/adminDoctor/changeOnline', async (params, api) => {
  return sendAsync(DT.doctorManagementUpload(params), api)
})

// 是否展示在线问诊状态
export const onlineInquiryUpload = createAsyncThunk<
  void,
  DT.DoctorManagementUploadPrams,
  RootThunkApi<void>
>('clinic/getDoctorManagementUpload', async (params, api) => {
  return sendAsync(DT.onlineInquiryUploadFn(params), api)
})

export const getChangeFunctionalStatus = createAsyncThunk<
  void,
  DT.ChangeFunctionalStatusPrams,
  RootThunkApi<void>
>('clinic/getChangeFunctionalStatus', async (params, api) => {
  return sendAsync(DT.changeFunctionalStatus(params), api)
})


// 获取-挂号-医生
export const getAllDoctorList = createAsyncThunk<
  any,
  getAllDoctorListFnPrams,
  RootThunkApi
>('ToothHome/getAllDoctorList', async (params, api) => {
  return sendAsync(getAllDoctorListFn(params), api)
})
